// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__ushk0","alert":"SettungsInbox_alert__19iCe"};